import styles from "./list-item.module.css";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

export interface ListItemAction {
  iconName?: UIIconName;
  title?: string;
  onClick: () => void;
}

interface ListItemProps {
  preview: React.ReactNode;
  title: string;
  description: string;
  textLinkActions?: ListItemAction[];
  trailingIconActions?: ListItemAction[];
}

export const ListItem = (props: ListItemProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.leadingContent}>
        <div className={styles.itemPreview}>{props.preview}</div>
        <div className={styles.labelsAndControlsContainer}>
          <div className={styles.labelContainer}>
            <h1>{props.title}</h1>
            <p>{props.description}</p>
          </div>
          <div className={styles.controlsContainer}>
            {props.textLinkActions?.map((action, index) => (
              <button key={index} onClick={action.onClick}>
                <span>{action.title}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.trailingContent}>
        {props.trailingIconActions?.map((action, index) => (
          <UIIconButton
            key={index}
            iconName={action.iconName ?? "CHECK"}
            onClick={action.onClick}
            width={30}
            height={30}
          />
        ))}
      </div>
    </div>
  );
};
